import React from 'react';
import { makeStyles } from 'tss-react/mui';
import 'ha/css.legacy/app.css';

import { Organization, WebSite } from 'ha/components.legacy/LinkedData';
import { useFeatureFlags } from 'ha/modules/FeatureFlags';
import { TopCities as list } from '../constants';
import { HermesData } from '../types';
import { Hero } from './Hero';
import { HomeHelmet } from './HomeHelmet';
import { TopCitiesContainer as TopCities } from '../containers/TopCities';
import { InfoSection } from './InfoSection';
import { FeaturedCitiesContainer as FeaturedCities } from '../containers/FeaturedCities';
import { Separator } from './Separator';
import { BlogCards } from './BlogCards';
import { FeaturedCountries } from './FeaturedCountries/FeaturedCountries';
import { UkraineBanner } from './UkraineBanner';

export interface Props {
  data: HermesData | undefined;
}

const useStyles = makeStyles()(theme => ({
  container: {
    paddingBottom: theme.spacing(9),
  },
}));

const HomeLayout: React.FC<Props> = ({ data }) => {
  const { forUkraineAdvertiser, forUkraineTenant } = useFeatureFlags();
  const { classes } = useStyles();

  const hasContent = React.useMemo(
    () => Boolean(data?.promotedContent?.length),
    [data],
  );

  return (
    <div className={classes.container}>
      <HomeHelmet />
      <Organization />
      <WebSite />
      <Hero />
      <TopCities list={list} />
      <Separator rotate />
      <InfoSection />
      <FeaturedCities />
      <Separator />
      <FeaturedCountries />

      {data && hasContent && (
        <React.Fragment>
          <Separator rotate />
          <BlogCards data={data} />
        </React.Fragment>
      )}

      {forUkraineAdvertiser === 'on' && forUkraineTenant === 'on' && (
        <UkraineBanner />
      )}
    </div>
  );
};

export { HomeLayout };
